/**
 * Detects lazy-route chunk load failures across browsers (tickets/3269).
 *
 * Route components load lazily, so a deploy that ships while users have the
 * app open invalidates the hashed chunk URLs their session still references.
 * The browser wordings for the failed dynamic import differ:
 *
 *   Chrome/Edge : "Failed to fetch dynamically imported module"
 *   Firefox     : "error loading dynamically imported module" /
 *                 "Importing a module script failed"
 *   Safari/iOS  : "Load failed"  ← was missing from the router's recovery
 *                 matcher, so Safari users never recovered and kept seeing
 *                 the failure (V-APP-16C, 271 events / 50 users since
 *                 Mar 2025).
 *
 * "Load failed" is Safari's generic fetch-failure wording, not chunk-specific
 * — a false positive (network flake, CORS) is accepted because the recovery
 * path reloads at most once per route (sessionStorage guard in router.ts).
 * The `\b` boundary keeps lookalikes ("Preload failed", "Upload failed")
 * from matching.
 */
export const CHUNK_LOAD_FAILURE_RE =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|\bLoad failed\b/i

export const isChunkLoadFailure = (error: unknown): boolean =>
  CHUNK_LOAD_FAILURE_RE.test((error as { message?: string } | null | undefined)?.message ?? '')
